import moment from 'moment-timezone';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import EventController from '../controllers/EventController';
import EventDetailsViewModel from '../models/events/GetEventDetails/EventDetailsViewModel';
import $ from "jquery";
import "datatables.net"
import "datatables.net-dt"
import 'datatables.net-dt/css/jquery.dataTables.min.css'

export default function EventDetails() {
    let { eventId } = useParams<{eventId: string}>();

    const [loading, setLoading] = useState(true);
    const [event, setEvent] = useState<EventDetailsViewModel | null>(null);
    const eventController = new EventController();


    const getEvent = async () => {
        if(!event){
            var currentEvent = await eventController.GetEventDetails(eventId)
            setEvent(currentEvent);
            $('#attendeeTable').DataTable();
        }
    }
        
    useEffect(() => {
        getEvent();
    })

    return (
        <div className="col-12 mx-auto">
            <h1 className="text-center">{event?.Name}</h1>
            <h2 className="text-center">{event?.Hosts}</h2>
            <div className="text-center">
            <span>Rewards Loyalty: {event?.AllowsLoyalty.toString()}</span><br />
            <span>Start Time: {moment.utc(event?.StartDate).tz('Europe/London').format("ddd DD MMM yyyy HH:mm")}</span><br />
            <span>End Time: {moment.utc(event?.EndDate).tz('Europe/London').format("ddd DD MMM yyyy HH:mm")}</span><br />
            </div>
            <br />
            <h3>Attendees</h3>
            <table id="attendeeTable" className="table table-dark">
                <thead>
                    <tr>
                        <th scope="col">First Name</th>
                        <th scope="col">Surname</th>
                        <th scope="col">Key Number</th>
                        <th scope="col">Entry Time</th>
                        <th scope="col">Exit Time</th>
                        <th scope="col">Used Loyalty?</th>
                    </tr>
                </thead>
                <tbody>
                {event?.Attendees && event.Attendees.map((attendee, index) => {
                        return  <tr key={index.toString()} >
                                    <td scope="row" style={{ textAlign: "left" }}>{attendee.FirstName}</td>
                                    <td style={{ textAlign: "left" }}>{attendee.Surname}</td>
                                    <td style={{ textAlign: "left" }}>{attendee.KeyNumber}</td>
                                    <td style={{ textAlign: "left" }}>{moment.utc(attendee.EntryTime).tz('Europe/London').format("ddd DD MMM yyyy HH:mm")}</td>
                                    <td style={{ textAlign: "left" }}>{moment.utc(attendee.ExitTime).tz('Europe/London').format("ddd DD MMM yyyy HH:mm")}</td>
                                    <td style={{ textAlign: "left" }}>{attendee.UsedLoyalty.toString()}</td>
                                </tr>
                    })
                    }
                </tbody>
            </table>
        </div >
        
    );
}